import { GupshupMessage } from "../interfaces";
import { StepsBDMedicalAppointment } from "./model";

export interface IConversationCreatedEvent { }
export interface IConversationUpdatedEvent { }
export interface IConversationStartedEvent { }
export interface IConversationEndedEvent { }
export interface IConversationSuspendedEvent {
    conversationId: string;
    until: number;
}
export interface IConversationAddAttributeRequestEvent {
    data: {
        name: string;
        type: any;
        value: any;
        label?: any;
    }[]
    conversationId: string;
}
export interface IConversationRemoveAttributeRequestEvent {
    name: string;
    conversationId: string;
}
export interface IConversationAddAttributeEvent {
    data: {
        name: string;
        type: any;
        value: any;
        label?: any;
        _id: string;
    }[]
    conversationId: string;
    workspaceId: string;
    conversation: any;
}
export interface IConversationRemoveAttributeEvent {
    name: string;
    conversationId: string;
    _id: string;
    workspaceId: string;
}
export interface IConversationRedirectedEvent { }
export interface IConversationAssignRequestEvent {
    assignedByMember: any;
    conversationId: string;
    team: {
        name: string;
        attendancePeriods: {
            [key: string]: { start: number, end: number }[]
        };
        workspaceId: string;
        _id: string
    };
    userId?: string | null;
    priority?: number | null;
}

export interface IConversationAssignEvent {
    assignedByMember: any;
    conversation?: any;
    conversationId: string;
    team: {
        name: string;
        attendancePeriods: {
            [key: string]: { start: number, end: number }[]
        };
        workspaceId: string;
        _id: string
    };
    userId?: string | null;
    priority?: number | null;
}

export interface IConversationMetricsUpdatedEvent { }

export interface IConversationUnredirectedEvent { }
export interface IConversationUpdatedEvent { }
export interface IConversationTagsUpdatedEvent { }
export interface IConversationMemberAddedEvent { }
export interface IConversationMemberRemovedEvent { }
export interface IConversationMemberUpdatedEvent { }
export interface IConversationMemberUploadAttachment { }
export interface IConversationWhatsappExpirationUpdated {
    conversationId: string;
    timestamp: number;
    conversation: any;
    phoneNumber: string;
}
export interface IConversationContextChangedEvent {
    bot: any;
    workspace: any;
    index: number;
    fromInteraction: any;
    toInteraction: any;
    conversationId: string;
    activityId: string;
    incoming: any;
}

export interface IActivityReceivedEvent { }
export interface IActivitySyncEvent {
    activities: any[];
}
export interface IActivityHashUpdatedEvent {
    activityId: string;
    hash: string;
}

export interface IActivitySendedEvent {
    activity: {
        type: string,
        text: string,
        value: { interactionId: string, score: number },
        locale: string,
        /**
         * format : '2020-03-20T14:20:27.463Z'
         */
        localTimestamp: string,
        /**
         * format : '2020-03-20T14:20:27.463Z'
         */
        timestamp: string,
        from:
        {
            id: string,
            name: string,
            channelId: string,
            data: any
        },
        to:
        {
            id: string,
            name: string,
            channelId: string,
        },
        channelId: string,
        serviceUrl: string,
        conversationId: string,
        conversation: { id: string },
        id: string
    },
    conversation: any
}
export interface IActivityLastMessage { }
export interface IActivityIndexRequestEvent {
    conversation: any;
    activities: any[];
}


export interface IUserCreatedEvent { }
export interface IUserUpdatedEvent {
    _id: string;
    name: string;
}
export interface IUserDeletedEvent { }

export interface IChannelConfigCreatedEvent { }
export interface IChannelConfigWhatswebCreatedEvent { }
export interface IChannelConfigWhatswebUpdatedEvent { }
export interface IChannelConfigUpdatedEvent { }
export interface IChannelConfigDeletedEvent { }

export interface IAgentCreatedEvent { }
export interface IAgentUpdatedEvent { }
export interface IAgentDeletedEvent { }

export interface IWorkspaceCreatedEvent { }
export interface IWorkspaceUpdatedEvent { }
export interface IWorkspaceDeletedEvent { }

export interface IBotCreatedEvent { }
export interface IBotUpdatedEvent { }
export interface IBotDeletedEvent { }

export interface IContactCreatedEvent { 
    phone?: string;
    validNumber?: string;
    email?: string;
    avatar?: string;
    name: string;
    conversations: string[];
    lastConversationId?: string;
    createdByChannel: string;
    workspaceId: string;
    _id: string;
}
export interface IContactUpdatedEvent {
    phone?: string;
    validNumber?: string;
    email?: string;
    avatar?: string;
    name: string;
    conversations: string[];
    lastConversationId?: string;
    createdByChannel: string;
    workspaceId: string;
    _id: string;
 }
export interface IContactDeletedEvent { 
    _id: string;
}

export interface IInteractionCreatedEvent { }
export interface IBotPublishedEvent {
    interactionIds: string[];
    deletedInteractionIds: string[];
    workspaceId: string;
    botId: string;
}
export interface IInteractionUpdatedEvent { }
export interface IInteractionDeletedEvent { }
export interface IInteractionRecognizedEvent { }


export interface ISocketSendRequestEvent {
    data: any;
    room: string | string[];
}

//=============== MODELOS DA EXTENSÃO WHATSWEB
export interface IWhatswebQrCodeRequestEvent { }
export interface IWhatswebQrCodeResponseEvent {
    channel_config_id: string,
    token: string,
    qr_code: string
}

export interface IWhatswebScreenshotRequestEvent { }
export interface IWhatswebScreenshotResponseEvent { }

export interface IWhatswebDriverStatusRequestEvent { }
export interface IWhatswebDriverStatusResponseEvent { }

export interface IWhatswebSyncContactRequestEvent { }
export interface IWhatswebSyncContactResponseEvent { }

export interface IWhatswebSyncChatRequestEvent { }
export interface IWhatswebSyncChatResponseEvent { }

export interface IWhatswebUseHereRequestEvent { }
export interface IWhatswebCheckPhoneNumberResponseEvent {
    userId: string;
    token:string;
    phone:string;
    phoneId:string;
    whatsapp: string;
    isValid: boolean;
}

export interface IActiveMessageStatusChangedEvent {
    status: number;
    message: string;
    externalId: string;
    token: string;
    conversationId?: string;
}

export interface IWhatswebCheckPhoneNumberRequestEvent { }
export enum AckType {
    'Error' = -1,
    'Error500' = -500,
    'Pending' = 0,
    'ServerAck' = 1,
    'DeliveryAck' = 2,
    'Read' = 3,
    'Played' = 4,
    'NumberDontExists' = -2,
    'UserInactiveAndTemplateDontMatch' = -3,
    'UserInactiveAndNotOptedinTemplate' = -4,
    'UserInactiveOrNotOptedin' = -5,
    'InvalidMediaUrl' = -6,
    'InvalidMediaSize' = -7,
    'SendingToGupshupRequestError' = -8,
    'UserInactiveAndTemplateMessageDisabled' = -9,
    'UserInactiveAndNotOptedinAndTemplateNotMatch' = -10,
    'EmptyDestination' = -11,
    'OptinFailed' = -12,
    'CheckWalletBalance' = -13,
    'UserDontExists' = -14,
    'UserInactiveAndNotOptedinTemplateFromFacebook' = -407,
    'UserExperiment' = -472,
    'TemplateMissing' = -2001,
    'UserBlockingTemplate' = -1026,
    'MissingTemplateParams' = -2000,
    'CharacterPolicyViolated' = -2017,
    'InvalidReengagementMessage' = -470,
    'AccessDenied' = -1005,
    'TextOfTemplateTooLong' = -2005,
    'NoTemplateMatch' = -4003,
    'InvalidMessagePendingTooLong' = -408,
    'TemplateMarketingBlockedByUser' = -492,
    'ErrorMatchMedia' = -1014,
    'UnsupportedImageFormat' = -1000,
    'MessageTooLong' = -1001,
    'MessageUndeliverable' = -131026,
    'LimitTemplateMarketingExceeded' = -131049,
}

export interface IActivityAckAndHashUpdatedEvent {
    activityId: string;
    ack: AckType;
    hash: string;
    oldHash: string;
    conversationId: string;
}

export interface IAckEvent {
    ack: AckType;
    hash: string[];
    timestamp: string;
}

export interface IWhatswebMessageAck extends IAckEvent {}


export interface IAckToProcess extends IAckEvent {}

export interface IWhatswebMessageActivityExists {
    hash: string;
    phone: string;
    message: string;
}

export interface IWhatswebImportMessagesRequestEvent {
    phone: string,
    messageId?: string,
    count: number
}

export interface ILogCreated { }

export interface IAppointmentStepData {
    timestamp?: number; /* Date that sheduled is created */
    fromDateTimestamp?: number;
    untilDateTimestamp?: number;
    chosenPeriodOfDay? : string;
    appointmentTypeCode?: string;
    appointmentTypeName?: string;
    specialityCode?: string;
    specialityName?: string;
    procedureCode?: string;
    procedureName?: string;
    organizationUnitCode?: string;
    organizationUnitName?: string;
    doctorCode?: string;
    doctorName?: string;
    insuranceCode?: string;
    insuranceName?: string;
    insurancePlanName? : string;
    insurancePlanCode? : string;
    insuranceSubPlanName? : string;
    insuranceSubPlanCode? : string;
    insuranceCategoryCode? : string;
    insuranceCategoryName? : string;
    occupationAreaCode?: string;
    occupationAreaName?: string;
    organizationUnitLocationName?: string;
    organizationUnitLocationCode?: string;
    patientCode?: string;
    patientBornDate?: string;
    integrationId?: string;
    channelId: string /* source: webchat, whatsapp */
    workspaceId: string;
    botId: string;
    conversationId: string;
    lastUserAppointmentTimestamp?: number;
    lastUserAppointmentType?: string;
    nextUserAppointmentTimestamp?: number;
    nextUserAppointmentType?: string;
    listPatientAppointmentStatus?: number; // se deu erro ou nÃo ja hora de listar os agendamentos do paciente (0 ou 1)
    firstAvaliableDate?: number;
    avaliableDateCount?: number;
    confirmedAppointment?: boolean;
    step: StepsBDMedicalAppointment;
    chooseDoctor? : string;
    ctx_id?: string;
    typeOfServiceCode?: string;
    typeOfServiceName?: string;
    price?: string;
    followUpLimitDate?: string;
    referenceTypeOfService?: string; // se é retorno, ...
    referenceScheduleType?: string; 
}

export interface IReasonForNotSchedulingData {
    timestamp?: number; /* Date that sheduled is created */
    integrationId?: string;
    channelId: string /* source: webchat, whatsapp */
    workspaceId: string;
    botId: string;
    conversationId: string;
    ctx_id?: string;
    reasonCode: string;
    reasonName: string;
    reasonText: string;
}

export interface IAppointmentSheduledEvent {
    timestamp?: number; /* Date that sheduled is created */
    duration?: number; /* Duration in minutes of appointment */
    appointmentTypeCode: string;
    appointmentTypeName: string;
    specialityCode?: string;
    specialityName?: string;
    procedureCode?: string;
    procedureName?: string;
    organizationUnitCode?: string;
    organizationUnitName?: string;
    doctorCode?: string;
    doctorName?: string;
    insuranceCode?: string;
    insuranceName?: string;
    insurancePlanName? : string;
    insurancePlanCode? : string;
    insuranceSubPlanName? : string;
    insuranceSubPlanCode? : string;
    insuranceCategoryCode? : string;
    insuranceCategoryName? : string;
    occupationAreaCode?: string;
    occupationAreaName?: string;
    organizationUnitLocationName?: string;
    organizationUnitLocationCode?: string;
    appointmentCode?: string;
    appointmentDate?: number;
    patientCode?: string;
    patientCpf?: string;
    patientPhone?: string;
    patientBornDate?: string;
    integrationId?: string;
    channelId: string /* source: webchat, whatsapp */
    workspaceId: string;
    botId: string;
    conversationId: string;
    lastUserAppointmentTimestamp?: number;
    lastUserAppointmentType?: string;
    nextUserAppointmentTimestamp?: number;
    nextUserAppointmentType?: string;
    listPatientAppointmentStatus?: number; // se deu erro ou nÃo ja hora de listar os agendamentos do paciente (0 ou 1)
    chooseDoctor? : string;
    ctx_id?: string;
    typeOfServiceCode?: string;
    typeOfServiceName?: string;
    price?: string;
    followUpLimitDate?: string;
    referenceTypeOfService?: string; // se é retorno, ...
    referenceScheduleType?: string; 
}

export interface IGupshupMessageDeliveredEvent {
    message: GupshupMessage,
    channelConfigToken: string;
    workspaceId?: string;
}

export interface IGupshupNumberDontExistsReceivedEvent {
    conversationId: string;
    workspaceId: string;
}

export interface IInteractionFallbackRecognizedEvent {
    interactionId: string;
    botId: string;
    workspaceId: string;
    interactionName: string;
    message: string;
    recognizedTimestamp: number;
    contextId?: string;
    conversationId?: string;
    channelId?: string;
}

export interface IWhatsAppSessionCountIncrementEvent {
    whatsappSessionCount: number;
    conversationId: string;
}

export interface IContactBlockedEvent {
    phone: string;
    isBlocked: boolean;
    appName: string;
    contactId: string;
}

export interface IBillingCreatedPaymentEvent {
    id?: number;
    accountId: number;
    workspaceId: string;
    billingStartDate: number;
    billingEndDate: number;
    billingMonth: string;
    items?: {
        id?: number;
        itemDescription: string;
        quantity: number;
        unitPrice: number;
        totalPrice: number;
        type: string;
        paymentId?: number;
    }[]
}

export interface IRatingReceivedEvent {
    id: number;
    ratingFeedback: string;
    value: number;
    conversationId: string;
    workspaceId: string;
    teamId: string;
    channel: string;
    ratingSendedAt: number;
}